import { Lib } from '@/types'
import { memo } from 'react'
import SectionSeparatorFragment from './query'

export type SectionSeparatorData = Lib.FragmentOf<
  typeof SectionSeparatorFragment
> & {
  _modelApiKey: 'section_separator'
  __typename: 'SectionSeparatorRecord'
}

const SectionSeparator = () => {
  return <hr />
}

export default memo(SectionSeparator)
